import { createPortal } from 'react-dom';
import { usePortal } from '@src/hooks/usePortal/usePortal';
import './Portal.scss';

export const Portal = ({ id, children, modalContentClassName }) => {
  const target = usePortal(id, modalContentClassName);
  return createPortal(children, target);
};
